import Utilities from "@util/Utilities";


export const controlStyles = (hasError: boolean, isDisabled?: boolean) => {
    return {
        base: Utilities.classNames("border rounded-md hover:cursor-pointer sm:text-sm shadow-sm", isDisabled ? "bg-gray-100" : "bg-white"),
            focus: Utilities.classNames(hasError ? "text-rose-900 border-red-500 placeholder:text-rose-500 focus:border-red-500" : "ring-2 ring-inset ring-blue-600"),
        nonFocus: Utilities.classNames(hasError ? "text-rose-900 border-red-300 placeholder:text-rose-300 focus:border-red-500" : "border-slate-300 "),
    }
};
export const placeholderStyles = (hasError: boolean) => Utilities.classNames(hasError ? "text-rose-900" : "text-slate-400", "pl-1 py-0.5 absolute");
export const selectInputStyles = "pl-1 py-0.5";
export const valueContainerStyles = "p-1 gap-10";
export const singleValueStyles = "leading-7 ml-1 absolute -bottom-0.5";
export const multiValueStyles =
    "bg-slate-100 rounded items-center py-0.5 pl-2 pr-1 gap-1.5";
export const multiValueLabelStyles = "leading-6 py-0.5";
export const multiValueRemoveStyles =
    "border border-slate-200 bg-white hover:bg-red-50 hover:text-rose-800 text-slate-500 hover:border-red-300 rounded-md";
export const indicatorsContainerStyles = "p-1 gap-1";
export const clearIndicatorStyles =
    "text-slate-500 p-1 rounded-md hover:bg-red-50 hover:text-rose-500";
export const indicatorSeparatorStyles = "bg-slate-300";
export const dropdownIndicatorStyles =
    "p-1 hover:bg-slate-100 text-slate-500 rounded-md hover:text-black";
export const menuStyles = "p-1 mt-2 border border-slate-200 bg-white rounded-lg z-20";
export const groupHeadingStyles = "ml-3 mt-2 mb-1 text-slate-500 text-sm";
export const optionStyles = {
    base: "hover:cursor-pointer px-3 py-2 rounded sm:!text-sm",
    focus: "bg-slate-100 active:bg-slate-200",
    selected: "color-green-600",
};
export const noOptionsMessageStyles =
    "text-slate-500 p-2 bg-slate-50 border border-dashed border-slate-200 rounded-sm sm:!text-sm z-20";
export const loadingMessageStyles =
    "text-slate-500 p-2 bg-slate-50 border border-dashed border-slate-200 rounded-sm sm:!text-sm z-20";
export const menuPortalStyles =
    "!z-20";